import { Typography, Box } from '@mui/material';
import { Resources } from '@ragu-components/ord-resources';
import { useGetList, useGetRecordId, useTranslate } from 'react-admin';
import { Link } from 'react-router-dom';

import { AclResourcesInput } from './AclResourcesInput';

import type { RoleRead } from '@ragu-components/ord-types';
import type { InputProps } from 'react-admin';

/**
 * AclResourcesInput for user
 * The difference with AclResourcesInput is that it also gets the inherited resources from the groups where the user belongs
 */
export const UserAclResourcesInput = (props: InputProps): React.ReactElement => {
  const id = useGetRecordId();
  const translate = useTranslate();
  const { data: roles } = useGetList<Required<RoleRead>>(Resources.roles, {
    filter: { active: 'fiql', fiql: `users.id==${id}` },
  });

  const inheritedFrom = (roles ?? []).filter((role) => role.acl_resources.length > 0);

  return (
    <>
      {inheritedFrom.length > 0 && (
        <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
          <Box display='flex' gap={1}>
            {translate('ord.permissions.inheritedResourcesDescription')}
            {`: `}
            {inheritedFrom.map(({ id, name }) => (
              <Link key={id} to={`/${Resources.roles}/${id}`}>
                {name}
              </Link>
            ))}
          </Box>
        </Typography>
      )}
      <AclResourcesInput {...props} />
    </>
  );
};
